import React from 'react';
import { SnackbarContent, CustomContentProps } from 'notistack';

export const CustomSnackbar = React.forwardRef<
  HTMLDivElement,
  CustomContentProps
>((props, ref) => {
  return (
    <SnackbarContent ref={ref}>
      <div className="bg-white border border-gray-300 px-6 py-3 rounded-xl shadow-lg flex items-center justify-center w-[220px] mx-auto mt-20">
        <p className="font-medium text-lg">{props.message}</p>
      </div>
    </SnackbarContent>
  );
});

CustomSnackbar.displayName = 'CustomSnackbar';
